import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/messages/Page";

export const PATH = "/messages";

function Home() {
	return (
		<>
			<NskHead title="チャット" />
			<Component />
		</>
	);
}

export default Home;
